import React from "react";
import "./Hero.scss";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();
  return (
    <section className="hero-homepage">
      <div className="hero-text-homepage">
        <img
          className="nav-logo-img-tarbud"
          src="https://telegra.ph/file/35bf7773b08600ce79e17.png"
          alt="source"
        />
        <h1>Kelompok Ilmiah Remaja</h1>
        <p>
          Website official kirmago, di dedikasikan untuk anggota kelompok ilmiah
          remaja{" "}
          <a href="https://www.instagram.com/smanrogtb_oFFicial/">
            SMAN 1 ROGOJAMPI
          </a>
        </p>
        <button
          onClick={() => navigate("/anggota/registrasi-anggota")}
          className="hero-button-homepage-daftar"
        >
          Daftar
        </button>
      </div>
      <img
        className="flat-teammate"
        src="https://telegra.ph/file/89c846db1610b97fd0fb5.png"
        alt="source"
      />
      <div className="hero-copyright">
        <p>
          source code by{" "}
          <a href="https://www.instagram.com/thirteenrxdho/">ryznxx</a>
        </p>
        <p>Re-code KIRMAGO {new Date().getFullYear()}</p>
      </div>
    </section>
  );
};

export default Hero;
